/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganisationList } from '../../models/organisation-list';

export interface OrganisationGetOrganisationList$Params {
}

export function organisationGetOrganisationList(http: HttpClient, rootUrl: string, params?: OrganisationGetOrganisationList$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganisationList>> {
  const rb = new RequestBuilder(rootUrl, organisationGetOrganisationList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrganisationList>;
    })
  );
}

organisationGetOrganisationList.PATH = '/organisation/list';
